import Animation from './animation'
import * as array from 'd3-array'
import * as d3 from 'd3-selection'

/*
 * This reference band animation is used when the number of thresholds in
 * the reference band serie changes. It doesn't transition, it immediately
 * removes the old state and replaces it with the new objects.
 */
class ThresholdChangeAnimation extends Animation {

  match (serie) {
    if (!this.chart.previous) {
      // Not an update
      return false
    }

    let prev = this.previous.series.data().find(s => s.id == serie.id)
    if (!prev) {
      // Didn't have this serie previously
      return false
    }

    // Determine the previous number of threshold lines
    // This is a hacky approach looking into the DOM.
    let count0 = array.max(this.series.selectAll('.reference-breakdown').nodes(), node => {
      return d3.select(node).selectAll('path.line').size()
    })

    // Now how many thresholds
    let count1 = array.max(serie.points, p => {
      return p && p.thresholds && p.thresholds.length
    })

    return count0 !== count1
  }

  animate (serie, enter, selection, merged, exit) {
    selection.selectAll('*').remove() // Remove all the previous bands

    let _selection = merged.selection() // All elements
    this._fills(_selection, merged)
    this._lines(_selection, merged)

    // We don't want the elements to fade in. Immediately show them.
    _selection.selectAll('path.line').style('opacity', d => d.opacity)
    _selection.selectAll('path.fill').style('opacity', d => d.opacity)
  }

}

export default ThresholdChangeAnimation
